// The arithmetic of StackedMeter (stacked-meter.tsx): which segments show and how wide each is.

export interface MeterInput {
  value: number;
}

/**
 * Each segment's share of `total` in percent, in input order. Segments at or below 0 (or not finite) are dropped.
 * `total` defaults to the sum of the values; a smaller total is raised to the sum so the bar never overflows, and a
 * larger one leaves the rest of the track empty. Returns `[]` when nothing is above 0.
 */
export function meterWidths<T extends MeterInput>(segments: readonly T[], total?: number): (T & { percent: number })[] {
  const shown = segments.filter((segment) => Number.isFinite(segment.value) && segment.value > 0);
  const sum = shown.reduce((acc, segment) => acc + segment.value, 0);
  if (sum <= 0) return [];
  const whole = total !== undefined && Number.isFinite(total) && total > sum ? total : sum;
  return shown.map((segment) => ({ ...segment, percent: (segment.value / whole) * 100 }));
}
